<template>
  <data-input v-if="visible && (partnerId || allowImport)" label="企业微信">
    <span class="wx-name" :class="{empty: !displayName}">{{ displayName || '未关联' }}</span>
    <span v-if="actionText" class="wx-action" @click="onAction">{{ actionText }}</span>
  </data-input>
</template>

<script>
import DataInput from "@/components/qywx/data/DataInput.vue";
import partnerWxInfoApi from "@/api/dz-crm/partner/partnerWxInfoApi";
import qywxUtil from "@/util/qywxUtil";
import Util from "@/util/util";
import {ElMessageBox} from "element-plus";

export default {
  name: "MobilePartnerWxBind",
  components: {DataInput},
  props: {
    partnerId: {default: ""},
    allowImport: {default: false},
  },
  data() {
    return {
      association: null,
      pendingContact: null,
      pendingExternalId: "",
      binding: false,
    };
  },
  computed: {
    visible() {
      return [2, 3].includes(Util.getContextPath());
    },
    displayName() {
      if (this.association) {
        return this.association.qywxUserName || this.association.qywxExternalId || "已关联";
      }
      return this.pendingContact ? this.pendingContact.userName : "";
    },
    actionText() {
      if (this.partnerId && this.association) {
        return "解除绑定";
      }
      if (this.partnerId) {
        return this.binding ? "处理中..." : "关联";
      }
      if (this.allowImport) {
        return this.binding ? "处理中..." : "从企业微信导入";
      }
      return "";
    },
  },
  watch: {
    partnerId: {
      immediate: true,
      handler(value) {
        if (value) {
          this.loadAssociation();
          if (this.pendingExternalId) {
            this.bindPending(value);
          }
        } else {
          this.association = null;
        }
      },
    },
  },
  methods: {
    loadAssociation() {
      if (!this.partnerId) {
        this.association = null;
        return;
      }
      partnerWxInfoApi.findByPartnerId(this.partnerId).then(res => {
        this.association = res || null;
      }).catch(() => {
        this.association = null;
      });
    },
    onAction() {
      if (this.binding) {
        return;
      }
      if (this.partnerId && this.association) {
        this.confirmUnbind();
      } else if (this.partnerId) {
        this.bind();
      } else if (this.allowImport) {
        this.importContact();
      }
    },
    confirmUnbind() {
      ElMessageBox.confirm("确定解除企业微信绑定吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        partnerWxInfoApi.unbind(this.partnerId).then(() => {
          this.association = null;
          this.$message.success("已解除绑定");
          this.$emit("unbound");
        });
      }).catch(() => {
      });
    },
    bind() {
      this.binding = true;
      qywxUtil.selectExternalContactSingle().then(externalUserId => {
        return partnerWxInfoApi.bind(this.partnerId, externalUserId);
      }).then(res => {
        this.association = res || null;
        this.$message.success("关联成功");
        this.$emit("bound", this.association);
      }).catch(err => {
        if (err && err.errMsg === "multiple") {
          this.$message.warning(err.message || "一次只能选择一个企业微信客户");
          return;
        }
        if (err && err.errMsg && err.errMsg.indexOf("cancel") === -1) {
          this.$message.error("关联失败，请稍后重试");
        }
      }).finally(() => {
        this.binding = false;
      });
    },
    /** 新建客户：选择企业微信客户并回填，提交时才保存客户 */
    importContact() {
      this.binding = true;
      qywxUtil.selectExternalContactSingle().then(externalUserId => {
        return partnerWxInfoApi.fetchExternalContact(externalUserId);
      }).then(contact => {
        if (!contact) {
          return;
        }
        this.pendingContact = contact;
        this.pendingExternalId = contact.externalUserId;
        this.$emit("imported", contact);
      }).catch(err => {
        if (err && err.errMsg === "multiple") {
          this.$message.warning(err.message || "一次只能选择一个企业微信客户");
          return;
        }
        if (err && err.errMsg && err.errMsg.indexOf("cancel") === -1) {
          this.$message.error("获取企业微信客户失败，请稍后重试");
        }
      }).finally(() => {
        this.binding = false;
      });
    },
    /** 客户保存后补关联；新建页在跳转前 await */
    bindPending(partnerId) {
      if (!this.pendingExternalId) {
        return Promise.resolve(null);
      }
      return partnerWxInfoApi.bind(partnerId, this.pendingExternalId).then(res => {
        this.association = res || null;
        this.pendingContact = null;
        this.pendingExternalId = "";
        this.$emit("bound", this.association);
        return res;
      }).catch(() => {
        this.$message.warning("客户已保存，但企业微信关联失败，请在客户详情中重新关联");
        return null;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wx-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--el-color-primary);
  font-size: var(--yq-font-size-mini-mobile);

  &.empty {
    color: var(--yq-font-color-desc);
  }
}
.wx-action {
  flex: none;
  margin-left: 10px;
  color: var(--el-color-primary);
  font-size: var(--yq-font-size-mini-mobile);
}
</style>
